import { supabase } from '../lib/supabase';
import { v4 as uuidv4 } from 'uuid';

// Get or create a session ID
const getSessionId = () => {
  let sessionId = localStorage.getItem('interaction_session_id');
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem('interaction_session_id', sessionId);
  }
  return sessionId;
};

// Track an interaction
export const trackInteraction = async (publicLinkId, eventType, linkType, metadata = {}) => {
  try {
    const sessionId = getSessionId();
    
    await supabase.rpc('track_interaction', {
      p_public_link_id: publicLinkId,
      p_event_type: eventType,
      p_link_type: linkType,
      p_session_id: sessionId,
      p_ip_address: null, // We'll let the server handle this
      p_user_agent: navigator.userAgent,
      p_metadata: metadata
    });
  } catch (error) {
    console.error('Error tracking interaction:', error);
  }
};

// Track time spent
let startTime = null;
let timeTrackingInterval = null;

export const startTimeTracking = (publicLinkId, linkType) => {
  startTime = new Date();
  
  // Clear any existing interval
  if (timeTrackingInterval) {
    clearInterval(timeTrackingInterval);
  }
  
  // Update time spent every minute
  timeTrackingInterval = setInterval(() => {
    const duration = Math.floor((new Date() - startTime) / 1000); // Duration in seconds
    trackInteraction(publicLinkId, 'time_spent', linkType, { duration });
  }, 60000); // Every minute
};

export const stopTimeTracking = () => {
  if (timeTrackingInterval) {
    clearInterval(timeTrackingInterval);
    timeTrackingInterval = null;
  }
  startTime = null;
};

// Track section views using Intersection Observer
export const trackSectionViews = (publicLinkId, linkType) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionName = entry.target.getAttribute('data-section-name');
          if (sectionName) {
            trackInteraction(publicLinkId, 'section_viewed', linkType, {
              section_name: sectionName,
              visible_time: Math.round(entry.time)
            });
            // Unobserve after first view to prevent multiple events
            observer.unobserve(entry.target);
          }
        }
      });
    },
    {
      threshold: 0.5, // Trigger when 50% of the section is visible
      rootMargin: '0px'
    }
  );

  // Find and observe all sections
  const sections = document.querySelectorAll('[data-section-name]');
  sections.forEach(section => observer.observe(section));

  return observer;
}; 